import PageHeader from '../components/PageHeader';
import secondHeader from '../assets/images/secondHeader.png';
import blackCalender from '../assets/images/blackCalender.png';
import timeBG from '../assets/images/timeBG.png';
import AnimatedSection, { AnimatedGroup, AnimatedItem } from '../components/AnimatedSection';
import { Coffee, MessageSquareText, Mic2 } from 'lucide-react';

const schedule = [
    {
        time: '11:10 - 11:00',
        title: 'حفل الافتتاح',
        icon: Mic2,
        events: [
            'السلام الملكي',
            'فيديو مرئي قصير',
            'الكلمات الافتتاحية - كلمة رئيس جامعة الملك سعود المُكلف أ.د. علي بن محمد مسملي',
        ],
    },
    {
        time: '11:50 - 11:10',
        title: 'الجلسة الافتتاحية',
        icon: MessageSquareText,
        events: ['الحوكمة: اختلاف النهج بين التشريع والتنفيذ'],
    },
    {
        time: '12:00 - 11:50',
        title: 'استراحة',
        icon: Coffee,
        events: ['وقت للاستراحة والتواصل'],
        isBreak: true,
    },
    {
        time: '13:00 - 12:00',
        title: 'الجلسة الحوارية الأولى',
        icon: MessageSquareText,
        events: ['الجوانب القانونية للحوكمة وتمكين الأعمال'],
    },
    {
        time: '14:00 - 13:00',
        title: 'الجلسة الحوارية الثانية والختامية',
        icon: MessageSquareText,
        events: ['الجوانب القانونية للحوكمة في القطاع غير الربحي'],
    },
];

const Timeline = () => {
    return (
        <div dir="rtl">
            <PageHeader image={secondHeader} title="الجدول الزمني للمؤتمر" />

            <AnimatedSection
                className="min-h-screen pb-16 md:pt-[120px] pt-11 bg-cover bg-center flex flex-col items-center "
                style={{ backgroundImage: `url(${timeBG})` }}
                amount={0.05}
            >
                <div className="flex flex-col items-center gap-4 text-black font-bold text-xl relative z-20 px-4 text-center mb-12">
                    <div className="flex items-center gap-3">
                        <img src={blackCalender} alt="التاريخ" className="w-8 h-8" />
                        <span dir="ltr" className="tracking-widest text-2xl md:text-4xl font-semibold">
                            2026 - 09 - 13
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="mb-1 shrink-0"
                            aria-hidden="true"
                        >
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                            <circle cx="12" cy="10" r="3" />
                        </svg>
                        <span className="text-xl md:text-3xl font-semibold text-gray-800">
                            قاعة حمد الجاسر جامعة الملك سعود
                        </span>
                    </div>
                </div>

                <div className="relative z-10 mx-auto w-full max-w-[1100px] px-4">
                    <AnimatedGroup className="relative flex flex-col gap-6" stagger={0.12} amount={0.05}>
                        {schedule.map((item) => {
                            const Icon = item.icon;

                            return (
                                <AnimatedItem key={item.time}>
                                    <article
                                        className={`grid overflow-hidden rounded-2xl border bg-white shadow-[0_14px_35px_-22px_rgba(3,18,70,0.55)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_22px_45px_-22px_rgba(3,18,70,0.5)] md:grid-cols-[210px_minmax(0,1fr)] ${
                                            item.isBreak ? 'border-[#D3A35D]/40' : 'border-[#3E82B9]/15'
                                        }`}
                                    >
                                        <div
                                            className={`flex flex-row items-center justify-center gap-4 p-5 text-white md:flex-col md:p-7 ${
                                                item.isBreak
                                                    ? 'bg-gradient-to-br from-[#C79349] to-[#DDB978]'
                                                    : 'bg-gradient-to-br from-[#2F719E] to-[#55A0BC]'
                                            }`}
                                        >
                                            <Icon size={28} strokeWidth={1.8} aria-hidden="true" />
                                            <time dir="ltr" className="text-lg font-bold tracking-wider md:text-xl">
                                                {item.time}
                                            </time>
                                        </div>

                                        <div className="p-5 sm:p-7 md:p-8">
                                            <h3
                                                className={`mb-4 text-xl font-bold sm:text-2xl ${
                                                    item.isBreak ? 'text-[#A8732F]' : 'text-[#3E82B9]'
                                                }`}
                                            >
                                                {item.title}
                                            </h3>
                                            <div className="space-y-3">
                                                {item.events.map((event, eventIndex) => (
                                                    <div
                                                        key={event}
                                                        className={`flex items-start gap-3 rounded-xl px-4 py-3 text-base leading-relaxed sm:text-lg ${
                                                            item.isBreak
                                                                ? 'bg-[#D3A35D]/10 text-[#6B4C22]'
                                                                : 'bg-slate-50 text-[#031246]'
                                                        }`}
                                                    >
                                                        {!item.isBreak && (
                                                            <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-[#D3A35D]" />
                                                        )}
                                                        <span className={eventIndex === 0 && item.events.length > 1 ? 'font-semibold' : ''}>
                                                            {event}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </article>
                                </AnimatedItem>
                            );
                        })}
                    </AnimatedGroup>
                </div>
            </AnimatedSection>
        </div>
    );
};

export default Timeline;